import { useMemo } from 'react';
import { pick, prop } from 'js/utils/ramda.util';
import { useUserSelector } from 'js/store/hooks';
import { useFormatter } from 'js/hooks/useFormatter';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';

import { MAX_EXPORT } from '../constants';
import { useDynamicReducerSelector } from '../store';

export const useParams = (isExport = false) => {
    const formatter = useFormatter();
    const userName = useUserSelector(prop('userName'));
    const { consolidateBonusRounds, fields } = useComponentConfig();
    const {
        max,
        page,
        product,
        endDate,
        startDate,
        gamesSource
    } = useDynamicReducerSelector(pick([
        'max',
        'page',
        'product',
        'endDate',
        'startDate',
        'gamesSource'
    ]));

    return useMemo(() => ({
        page,
        fields,
        product,
        consolidateBonusRounds,
        playerUsername: userName,
        max: !isExport ? max : MAX_EXPORT,
        endDatetime: formatter.getDateForIms(endDate),
        startDatetime: formatter.getDateForIms(startDate),
        ...product === 'SPORTSBOOK' && {
            gamesSource
        }
    }), [
        max, page, fields, endDate, product, isExport, startDate,
        formatter, userName, gamesSource, consolidateBonusRounds
    ]);
};
